export default "__VITE_ASSET__cZVeWfWo__"